class CartStickyCheckout extends HTMLElement {
  connectedCallback() {
    this.cart = document.querySelector('cart-items');
    if (!this.cart) return;
    this.media = window.matchMedia('(max-width: 809px)');
    this.refresh = this.refresh.bind(this);
    this.visibility = this.visibility.bind(this);
    this.observer = new MutationObserver(this.refresh);
    this.observer.observe(this.cart, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-busy'] });
    this.intersection = new IntersectionObserver(entries => {
      this.mainVisible = entries[0].isIntersecting;
      this.visibility();
    });
    this.media.addEventListener('change', this.visibility);
    window.addEventListener('resize', this.visibility);
    this.addEventListener('holiday-notice:change', this.visibility);
    this.refresh();
  }

  refresh() {
    const main = this.cart.querySelector('.cart--button-checkout');
    const subtotal = this.cart.querySelector('[data-cart-page-subtotal]');
    if (main !== this.main) {
      this.intersection.disconnect();
      this.main = main;
      this.mainVisible = true;
      if (main) this.intersection.observe(main);
    }
    const shipping = this.cart.querySelector('[data-cart-shipping-information]')?.outerHTML || '';
    const shippingTarget = this.querySelector('[data-sticky-shipping-note]');
    if (shippingTarget && shipping !== this.shippingHTML) {
      this.shippingHTML = shipping;
      shippingTarget.innerHTML = shipping;
    }
    this.querySelector('[data-sticky-subtotal]').textContent = subtotal?.textContent.trim() || '';
    this.querySelector('button').disabled = this.cart.hasAttribute('aria-busy');
    this.visibility();
  }

  visibility() {
    this.hidden = !this.media.matches || !this.main || this.mainVisible;
    document.body.classList.toggle('has-cart-sticky-checkout', this.media.matches && !!this.main);
    cancelAnimationFrame(this.measureFrame);
    this.measureFrame = requestAnimationFrame(() => {
      document.body.style.setProperty('--cart-sticky-checkout-height', `${this.hidden ? 0 : Math.ceil(this.getBoundingClientRect().height)}px`);
    });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.intersection?.disconnect();
    this.media?.removeEventListener('change', this.visibility);
    window.removeEventListener('resize', this.visibility);
    this.removeEventListener('holiday-notice:change', this.visibility);
    cancelAnimationFrame(this.measureFrame);
    document.body.style.removeProperty('--cart-sticky-checkout-height');
    document.body.classList.remove('has-cart-sticky-checkout');
  }
}

if (!customElements.get('cart-sticky-checkout')) customElements.define('cart-sticky-checkout', CartStickyCheckout);
